import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PdCollectDataState, PdCollectDataSteps, PdCollectDataStore } from './pd-collect-data.store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SellerInfo } from '../../models/seller-info';

@Component({
  selector: 'app-pd-collect-data',
  templateUrl: './pd-collect-data.component.html',
  providers: [PdCollectDataStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdCollectDataComponent implements OnInit, OnDestroy {
  @Input() hash!: string;
  @Input() sellerInfo?: SellerInfo | null;
  @Input() initialBackButton = false;
  @Input() showProceedButton = true;
  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();

  public step$ = this.cs.currentStep$;
  public steps = PdCollectDataSteps;
  private subs = new Subscription();

  constructor(public readonly cs: PdCollectDataStore) {}

  public ngOnInit(): void {
    this.setInitialData();
    this.subscribeToGoBack();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private subscribeToGoBack(): void {
    this.subs.add(
      this.cs.currentStep$.pipe(filter((s) => s === PdCollectDataSteps.GoBack)).subscribe(() => {
        this.back.emit();
      }),
    );
    this.subs.add(
      this.cs.currentStep$.pipe(filter((s) => s === PdCollectDataSteps.Proceed)).subscribe(() => {
        this.next.emit();
      }),
    );
  }

  private setInitialData(): void {
    const state = {
      currentStep: PdCollectDataSteps.BusinessData,
      sellerHash: this.hash,
      shownFiles: {
        corporateCertificate: true,
        accountOwnerId: true,
        bankAccountOwnership: true,
        businessStamp: true,
      },
    } as PdCollectDataState;
    if (this.sellerInfo) {
      state.data = {
        businessData: {
          companyName: this.sellerInfo.seller_business_details.seller_merchant_name,
          businessNumber: this.sellerInfo.seller_business_details.seller_inc_code,
          addressCity: this.sellerInfo.seller_address.seller_address_city,
          addressStreet: this.sellerInfo.seller_address.seller_address_street,
          addressNumber: this.sellerInfo.seller_address.seller_address_street_number,
          vendorNumber: null,
          phone: this.sellerInfo.seller_personal_details.seller_phone,
        },
        bankData: {
          website: this.sellerInfo.seller_business_details.seller_site_url,
          businessType: this.sellerInfo.seller_business_details.seller_business_type,
          bankCode: this.sellerInfo.seller_business_details.seller_bank_account_code,
          bankBranch: this.sellerInfo.seller_business_details.seller_bank_account_branch,
          bankAccount: this.sellerInfo.seller_business_details.seller_bank_account_number,
        },
      };
    }
    this.cs.setState(state);
    // as initial state is set in ngOnInit, we need to call ngrxOnStoreInit manually
    this.cs.ngrxOnStoreInit();
  }
}
